<template>
<div class="chapter">
<div class="inner_page">
      ﻿
<title>DARKNESS RISING</title><link href="default.css" rel="stylesheet" type="text/css"/><link href="page-template.xpgt" rel="stylesheet" type="application/vnd.adobe.page-template+xml"/>
<p class="ctc11" id="p0007-01-0"><a id="page1"><span></span></a><a href="#/chapter3d#hc3" id="ch3">ACKNOWLEDGMENTS</a></p>
<p class="tx100" id="p0007-02-1"><span>Conceiving of and writing a book takes a leap of faith. Thank you to all the readers of the East Salem novels who have taken that leap of faith with me. I am humbled and inspired.</span></p>
<p class="tx" id="p0007-02-2"><span>Thank you, O’Reilly, from Wiehl. And Roger Ailes, who took a chance on hiring a certain legal analyst. And Dianne Brandi, whose judgment is infallible.</span></p>
<p class="tx" id="p0007-02-3"><span>Thank you to Pete’s lovely wife, Jen, and son, Jack, for all their patience. And to Bob Roe, for his keen eye and pen.</span></p>
<p class="tx" id="p0007-02-4"><span>Thank you to the amazing team at Thomas Nelson, including Daisy Hutton, senior vice president and publisher (a true visionary); Ami McConnell, senior acquisitions editor (and compatriot); L.B. Norton (so appreciate your work and sense of humor); Amanda Bostic, acquisitions editor (“brilliant” should be added to her title); Natalie Hanemann, senior editor; Becky Monds, associate editor (and a stellar human being); Jodi Hughes, editorial assistant. In marketing, thank you, Eric Mullett, marketing director; Ashley Schneider, marketing specialist; Ruthie Dean, publicity coordinator; Katie Bond, publicity manager (and one of the finest people I know); and Kristen Vasgaard, packaging manager (who is a creative genius). Your spirit and enthusiasm is wonderfully infectious. And a special thank-you to the awe-inspiring Allen Arnold, my friend always.</span></p>
<p class="tx" id="p0007-02-5"><span>Thank you to our book agents, Todd Shuster and Lane Zachary of the Zachary, Shuster, and Harmsworth Literary Agency. We couldn’t have done this without you!</span></p>
<p class="tx" id="p0007-02-6"><span>All of the mistakes are ours. All the credit is theirs. Thank you!</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter3.vue?7dadb720